import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { Nationality, UserData, UserDataFullPayload } from 'src/app/reservation/reservation.model';
import { DateService } from 'src/app/common/date.service';
import { ContactDestiny } from 'src/app/common/enums/ContactDestiny';
import { ReservationService } from 'src/app/reservation/reservation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReservationSummaryApiService } from 'src/app/reservation/reservation-summary/services/reservation-summary-api.service';

enum CustomerType {
	PRIVATE = 0,
	COMPANY = 1,
}

@Component({
	selector: 'app-tourism-events-user-add',
	templateUrl: './tourism-events-user-add.component.html',
	styleUrls: ['./tourism-events-user-add.component.scss'],
})
export class TourismEventsUserAddComponent implements OnInit {
	customerType = CustomerType;
	documentType = null;
	selectedCustomerType = CustomerType.PRIVATE;
	nationalities: Nationality[] = [];
	filteredUsers: UserData[];
	selectedUser: UserData = null;

	formGroup = new FormGroup({
		sex: new FormControl('', [Validators.required]),
		firstName: new FormControl('', [Validators.required]),
		lastName: new FormControl('', [Validators.required]),
		birth: new FormControl('', [Validators.required]),
		nationality: new FormControl(null),
		idNumber: new FormControl('', [Validators.pattern('^[A-Za-z]{3}\\s?\\d{6}$')]),
		passportNumber: new FormControl('', [Validators.pattern('^[A-Za-z]{2}\\s?\\d{7}$')]),
		phoneNumber: new FormControl('', [
			Validators.required,
			Validators.pattern('^\\+\\d{2,3}(?:(?:\\s\\d{3}){3}|\\d{9})$'),
		]),
		email: new FormControl('', [
			Validators.required,
			Validators.pattern('[^@ \\t\\r\\n]+@[^@ \\t\\r\\n]+\\.[^@ \\t\\r\\n]+'),
		]),
	});

	ngOnInit(): void {
		this.nationalities = this._reservationService.nationalities;
	}

	data = {
		ownerUser: false,
		ownerOrganization: null,
		documentType: null,
		documentNumber: null,
		birth: null,
		profile: {
			sex: null,
			first_name: null,
			last_name: null,
			nationality: null,
		},
		userConsent: [],
		userContacts: {
			phone: null,
			email: null,
			destiny: ContactDestiny.CONTACT,
		},
		userAddresses: [],
	};

	constructor(
		public dialogRef: MatDialogRef<TourismEventsUserAddComponent>,
		public _reservationService: ReservationService,
		private readonly apiService: ReservationSummaryApiService,
		protected bag: DataBagService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected loader: LoaderService,
	) {}

	protected cancel(): void {
		this.dialogRef.close();
	}

	changeDocumentType({ value }: MatSelectChange) {
		if (value === null) this.data.documentNumber = null;
	}

	controlFilledIncorrectly(controlName: string) {
		return this.formGroup.get(controlName).invalid && this.formGroup.get(controlName).value;
	}

	submit() {
		if (!this.formGroup.valid) return;
		let ownerUser: UserDataFullPayload = null;
		this.formGroup.markAllAsTouched();
		const { createUserDataFull } = this.apiService.actions();
		ownerUser = {
			regularCustomer: false,
			firstName: this.getControlValue('firstName'),
			lastName: this.getControlValue('lastName'),
			idNumber: this.getControlValue('idNumber')?.split(' ').join(''),
			passportNumber: this.getControlValue('passportNumber')?.split(' ').join(''),
			sex: this.getControlValue('sex'),
			birth: this.date.apiToDateTime(this.getControlValue('birth')).date,
			nationality: this.getControlValue('nationality'),
			userContacts: [
				{
					phone: this.getControlValue('phoneNumber').split(' ').join(''),
					email: this.getControlValue('email'),
					destiny: ContactDestiny.CONTACT,
				},
			],
			userConsent: [],
			userAddresses: [],
		};

		this.loader.show('create-userdata');
		createUserDataFull(ownerUser)
			.then(() => {
				this.infobox.success('Pomyślnie dodano klienta');
				this._reservationService.loadUsers();
				this.dialogRef.close();
			})
			.finally(() => {
				this.loader.hide('create-userdata');
			});
	}

	getControlValue(controlName: string): any {
		return this.formGroup.controls[controlName].value;
	}

	apiToDateTime(apiDate: string) {
		if (!apiDate) {
			return {
				date: null,
				time: null,
			};
		}
		const date = new Date(apiDate);
		const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
		return {
			date: dateString.slice(0, 10),
		};
	}

	changeSelectedData(value: boolean) {
		this.filteredUsers = [];

		if (value) this.data.ownerOrganization = null;
		else this.selectedUser = null;
	}
}
